@use '../../scss/global' as *;

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  position: relative;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  // ==== Sentinel Elements

  .sentinel-start,
  .sentinel-end {
    position: absolute;
    padding: 0;
    margin: 0;
  }

  .sentinel-start {
    top: 0;
    left: 0;
  }

  .sentinel-end {
    bottom: 0;
    right: 0;
  }

  // ==== Root Element

  .fluid-focus-trap--root {
    outline: none;
  }

  ::slotted(.fluid-focus-trap--root) {
    outline: none;
  }
}